import Vue from "vue";

Vue.component("static-content", {
	props: ["type", "language", "carded"],
	data() {
		return {
			content: "",
			title: "",
			loading: true
		};
	},
	methods: {
		getContent: function () {
			console.log(this.language);
			this.loading = true;
			this.$services.staticContents.getContent({
					type: this.type,
					language: this.language
				})
				.then((data) => {
					this.loading = false;

					if (data != null) {
						this.title = data.title;
						this.content = data.content;
					}
				});
		}
	},
	mounted() {
		this.getContent();
	},
	template: `
		<section class="card" v-if="carded">
			<header class="card-header">
				<h1 class="card-header-title">{{ title }}</h1>
			</header>
			<div class="card-content">
				<div class="content">
					<template v-if="loading">
						<loading></loading>
					</template>
					<template v-else>
						<slot name="before"></slot>
						<div v-html="content"></div>
						<slot name="after"></slot>
					</template>
				</div>
			</div>
		</section>
		<section v-else>
			<div class="content">
				<div v-if="loading">
					<loading></loading>
				</div>
				<div v-else v-html="content"></div>
			</div>
		</section>
	`
});